module.exports = __webpack_public_path__ + "static/media/sensor-on.69c1cf78.svg";